import { FC, useId } from 'react';
import classNames from 'classnames';

import styles from './RefinementList.module.scss';
interface RefinementListItemProps {
  label: string;
  value: string | number | boolean;
  isChecked: boolean;
  handleChange: (_value: string | number | boolean) => void;
  className?: string;
  count?: number;
}

const RefinementListItem: FC<RefinementListItemProps> = ({
  label,
  value,
  isChecked,
  handleChange,
  className,
  count = 0,
}) => {
  const id = useId();

  return (
    <label
      className={classNames(styles.filters_list_item, className)}
      htmlFor={id}
    >
      <input
        checked={isChecked}
        id={id}
        name={value.toString()}
        onChange={() => handleChange(value)}
        type="checkbox"
      />
      <span className={styles.filters_list_item__label}>{`${label}`}</span>
      {count > 0 && (
        <span className={styles.filters_list_item__count}>{count}</span>
      )}
    </label>
  );
};

export { RefinementListItem };
